import React, { useState, useEffect } from 'react';
import { LoadingGrid } from '../../../../_mexablock/helpers';
import { useGetAll } from '../hooks/AsignadasHook';
import { Filter } from '../_modals/Filter';
import { TableList } from '../../../../_mexablock/helpers/components/TableList';
import { MenuComponent } from '../../../../_mexablock/assets/ts/components';

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState(true);
  const [activeTab, setActiveTab] = useState<'activas' | 'inactivas'>(
    'inactivas'
  );
  const [initFilterValues, setInitFilterValues] = useState({
    iccid: '',
    type: 2,
  });

  const { data, loadingRequest } = useGetAll(initFilterValues);

  useEffect(() => {
    if (loadingRequest > 0) setloadingView(false);
  }, [loadingRequest]);

  setTimeout(() => {
    MenuComponent.reinitialization();
  }, 1000);

  const statusEnvio = (id: number, name: string) => {
    const badgeClasses: Record<number, string> = {
      9: 'badge-light-success',
      10: 'badge-light-primary',
      7: 'badge-light-info',
      8: 'badge-light-warning',
      11: 'badge-light-dark',
      16: 'badge-light-danger',
      17: 'badge-light-danger',
    };

    const badge = badgeClasses[id] ?? 'badge-light-secondary';
    return (
      <span
        className={`fs-7 fw-semibold badge ${badge} text-center d-inline-block`}
      >
        {name}
      </span>
    );
  };

  const columns: any = [
    {
      id: 'fecha_alta',
      name: <div className="fw-bolder text-muted me-5">Fecha Act.</div>,
      selector: (row: any) => row?.created_at ?? '',
      cell: (row: any) => {
        const fecha = row?.activation?.created_at;
        if (!fecha) return 'Pendiente';
        return new Date(fecha).toLocaleDateString('es-MX', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });
      },
      sortable: true,
    },
    {
      id: 'iccid',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => row?.iccid ?? '-',
      sortable: true,
    },
    {
      id: 'nombre',
      name: <div className="fw-bolder text-muted me-5">Estudiante</div>,
      selector: (row: any) => {
        const nombre = row?.activation?.customer?.first_name ?? '';
        const paterno = row?.activation?.customer?.father_last_name ?? '';
        const materno = row?.activation?.customer?.mother_last_name ?? '';
        const fullName = `${nombre} ${paterno} ${materno}`.trim();
        return fullName || 'Usuario pendiente';
      },
      sortable: true,
      width: '30%',
    },
    {
      id: 'colony',
      name: <div className="fw-bolder text-muted me-5">Estatus</div>,
      cell: (row: any) => {
        const id = row?.status?.id;
        const name = row?.status?.name ?? 'Sin estatus';
        return id ? statusEnvio(id, name) : <span>-</span>;
      },
      sortable: true,
    },
  ];

  const handleFilter = (values: any) => {
    setInitFilterValues({
      ...values,
      type: activeTab === 'activas' ? 1 : 2,
    });
  };

  const handleFilterClean = () => {
    setInitFilterValues({
      iccid: '',
      type: activeTab === 'activas' ? 1 : 2,
    });
  };

  return (
    <div className="row gy-5 g-xl-8">
      <div className="col-xl-12">
        <div className="card card-xxl-stretch mb-5 mb-xl-12">
          <div className="card-header border-0 pt-5 d-flex align-items-center justify-content-between flex-wrap gap-3">
            <div className="flex-grow-1 d-flex justify-content-start">
              <Filter
                initFilterValues={initFilterValues}
                onCleanFilter={handleFilterClean}
                onSearchFilter={handleFilter}
              />
            </div>

            <div className="flex-grow-1 d-flex justify-content-center">
              <ul className="nav">
                <li className="nav-item">
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1 ${
                      activeTab === 'inactivas' ? 'active' : ''
                    }`}
                    onClick={() => {
                      setActiveTab('inactivas');
                      setInitFilterValues((prev) => ({ ...prev, type: 2 }));
                    }}
                  >
                    Inactivas
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bold px-4 me-1 ${
                      activeTab === 'activas' ? 'active' : ''
                    }`}
                    onClick={() => {
                      setActiveTab('activas');
                      setInitFilterValues((prev) => ({ ...prev, type: 1 }));
                    }}
                  >
                    Activas
                  </a>
                </li>
              </ul>
            </div>

            <div className="flex-grow-1"></div>
          </div>

          {loadingView ? (
            <LoadingGrid text="Cargando..." />
          ) : (
            <TableList data={data} columns={columns} />
          )}
        </div>
      </div>
    </div>
  );
};

export { View };
